import { OverlayContainerView } from "./OverlayContainerView";
import { GalleryView, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { CuprosterWidget } from "../../widgets/View/VfWidget/CuprosterWidget";
import { RosterWidget } from "../../widgets/View/VfWidget/RosterWidget";

export class ManualOverlayContainerView extends OverlayContainerView {

    galleryView: GalleryView;
    cuprosterWidget: CuprosterWidget;
    rosterWidget: RosterWidget;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'manualOverlayContainerView';
        super( options );

        this.galleryView = this.addSubView( new GalleryView( { name: 'groupTablesGalleryView' } ) );

        // this.cuprosterWidget = null;

        if(srvg.widgets.enabled){
            if(srvg.widgets.widgets['cuproster'].enabled){
                this.cuprosterWidget = this.addSubView( new CuprosterWidget({
                    selector: '#tournamentRosterWidget',
                    platform: PLATFORM_OVERLAY_SMALL,
                    showTeamAbbr: false,
                    widgetGroup: 'VF'
                }));
            } else if(srvg.widgets.widgets['roster'].enabled){
                this.rosterWidget = this.addSubView( new RosterWidget({
                    selector: '#tournamentRosterWidget',
                    platform: PLATFORM_OVERLAY_SMALL,
                    showTeamAbbr: false,
                    widgetGroup: 'VF'
                }));
            }
        }
    }
}